import script from "./GiftView.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftView.vue?vue&type=script&setup=true&lang=js"

import "./GiftView.vue?vue&type=style&index=0&id=72824cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72824cbc"]])

export default __exports__